import { Avatar } from '../../../primitives';
import type { RegionalTeachersDto } from '../../regionalApi';

import { EM_DASH } from './roster-shared';

export default function AssistantsGrid({
  assistants,
}: {
  assistants: RegionalTeachersDto['assistants'];
}) {
  if (assistants.length === 0) {
    return (
      <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>
        No assistants listed — the teacher/assistant split ships with BON-144.
      </div>
    );
  }
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
      {assistants.map((a) => (
        <div
          key={a.userId}
          style={{
            padding: '10px 12px',
            background: 'var(--nb-surface)',
            border: '1px solid var(--nb-border)',
            borderRadius: 8,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Avatar name={a.name} color={a.avatarColor} size={22} />
            <div style={{ fontSize: 12, fontWeight: 700 }}>{a.name}</div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: 8,
              fontSize: 10.5,
              color: 'var(--nb-muted)',
            }}
          >
            <span>{a.ratePerHr === null ? EM_DASH : `$${a.ratePerHr}/hr`}</span>
            <span>
              {a.shiftsThisWeek} {a.shiftsThisWeek === 1 ? 'shift' : 'shifts'} this wk
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
